import React from 'react';
import { SectionCardTitleTypes } from './SectionCardTitleTypes';
export const SectionCardTitle = ({
  RenderAs = 'h3',
  children,
}: SectionCardTitleTypes.ISectionCardTitle) => {
  return (
    <RenderAs className="SectionCardTitle has-text-weight-bold">
      {children}
    </RenderAs>
  );
};
